var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.245,
    height: 22.458,
    viewBox: "0 0 22.245 22.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11461",
    "data-name": "Group 11461",
    transform: "translate(-193.581 -172.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458",
    transform: "translate(197.321 178.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    transform: "translate(3.076 0)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.973,
    cy: 4.194,
    rx: 3.973,
    ry: 4.194,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.973,
    cy: 4.194,
    rx: 3.473,
    ry: 3.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29637",
    "data-name": "Path 29637",
    d: "M134.941,2496.286s.159-7.266,6.957-7.314,7.448,7.314,7.448,7.314",
    transform: "translate(-134.941 -2479.712)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29638",
    "data-name": "Path 29638",
    d: "M667.127-309.536l10.365-8.307,5.236,4.279v-2.467h2.618v4.28l2.618,2.215",
    transform: "translate(-472.842 491.074)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonHome);
export default __webpack_public_path__ + "static/media/PersonHome.b1572d9e5f4a4c3a68cdf87489e31026.svg";
export { ForwardRef as ReactComponent };